/* eslint-disable */
import Lottie from 'lottie-web';

class LottiePlayer {

  constructor(container){

    this.container = container;

    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);
    this.handleEvents = this.handleEvents.bind(this);
    this.init = this.init.bind(this);

    this.init();
    this.handleEvents();

  }

  init() {

    this.container.classList.add('lottie--init');

    this.lottieConfig = {
      container: this.container.querySelector('.player'),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: this.container.dataset.mediaUrl
    };

    this.player = Lottie.loadAnimation(this.lottieConfig);


  }

  handleEvents() {

    /*this.$video.get(0).addEventListener('ended',() => {

      // self.carousel.carousel('next');
      this.$container.get(0).dispatchEvent(new CustomEvent('docarouselnext', {
        bubbles: true,
      }));

    });*/


  }

  play() {
    this.player.play();
  }

  stop() {
    this.player.stop();
  }

}

export default LottiePlayer;



// WEBPACK FOOTER //
// ./scripts/classes/videoplayer/lottie.js